import { useRef, useState } from 'react';

import { cn } from '@/utils/cn';

import styles from './uploader.module.css';

interface UploaderProps {
  accept?: string;
  onChange: (file: File | null) => void;
  value?: File | null;
}

export function Uploader({ accept, onChange, value }: UploaderProps) {
  const [dragOver, setDragOver] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) onChange(file);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    onChange(file);
  };

  return (
    <div
      className={cn(styles.dropzone, dragOver && styles.active)}
      onDragOver={(e) => {
        e.preventDefault();
        setDragOver(true);
      }}
      onDragLeave={() => setDragOver(false)}
      onDrop={handleDrop}
      onClick={() => inputRef.current?.click()}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') inputRef.current?.click();
      }}
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        className={styles.input}
        onChange={handleChange}
      />
      {value ? (
        <span className={styles.fileName}>{value.name}</span>
      ) : (
        <span className={styles.hint}>点击或拖拽文件到此处上传</span>
      )}
    </div>
  );
}
